<template>
  <div class="not-found-container">
    <h2 class="title-blue">{{ t("404_PAGE_NOT_FOUND") }}</h2>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";

const {t} = useI18n();
</script>

<style scoped lang="scss">
div.not-found-container {
  min-height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;

  h2 {
    padding: 1rem;
  }
}
</style>
